import React from 'react';

import { getPartnerTranslation } from 'Utilities/helpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';

import infoIcon from 'Images/icons/info-icon.svg';

type Props = {
  scopeType: string;
  scopes: string[];
  scopeDetails: ScopeDetails;
  partnerName: string;
  partnerType: string;
};

const scopeInfoClick = (scope: string, scopeDetails: ScopeDetails) => {
  mediator.publish('partner:consentInfo', { scope, scopeDetails });
};

/**
 *
 * @param {string} scopeType consent type eg. read or write
 * @param {string[]} scopes  all the items that are shared under this scope
 * @param {ScopeDetails} scopeDetails scope details object from partner
 * @param {string} partnerName name of the partner
 * @param {string} partnerType type of partner, mainly used for getting specific translations for a partner type if it exists
 * @returns a component that renders the sharing information for a particular scope
 */

const ScopeSection: React.FC<React.PropsWithChildren<Props>> = ({
  scopeType,
  scopes,
  scopeDetails,
  partnerName,
  partnerType,
}) => {
  if ((scopes && scopes.length === 0) || !scopeDetails) {
    return null;
  }

  const scopeItems = scopes.map((s) => (
    <div key={s} className="mt-2 pt-1" id={`${scopeType}Scope-${s}`}>
      <span id={`${scopeType}Scope-${s}-text`}>
        {i18n.t(`Scopes.${s.replace(/\./g, '_')}ScopeName`)}
      </span>
      <button
        className="btn btn-sm btn-round border-0 ml-2"
        id={`${scopeType}Scope-${s}-info-btn`}
        onClick={() => scopeInfoClick(s, scopeDetails)}
        type="button"
      >
        <img src={infoIcon} alt="info" />
      </button>
    </div>
  ));

  let sectionTitle = '';

  switch (scopeType) {
    case 'read':
      sectionTitle = getPartnerTranslation('Consent', partnerType, 'requestingAccess', {
        partnerName,
      });
      break;
    case 'write':
      sectionTitle = getPartnerTranslation('Consent', partnerType, 'receivedData', { partnerName });
      break;
  }

  return (
    <div className="d-flex flex-row">
      <div>
        <div className="font-weight-bold" id={`${scopeType}Scopes-title`}>
          {sectionTitle}
        </div>
        {scopeItems}
      </div>
    </div>
  );
};

export default ScopeSection;
